import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as actionType from '../../store/actions';
import classes from './StoreList.css';
import globalClasses from '../../App.css';
import RestaurantCard from '../../components/UI/RestaurantCard/RestaurantCard';
import Aux from '../../hoc/Aux/Aux';
import BookingPolicies from '../../components/bookingPolicies/BookingPolicies';
import Footer from '../../components/UI/Footer/Footer';

// MOCKS
import { bookingProcessSetStep, storeAvailabilityReset, promotionSelect, bookingProcessTermsAndPrivacyClicked } from '../../store/actions/bookingProcess';
import { BOOKING_STEPS } from '../../constants';
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';
import { storesGetList, storesSelectCountry, countriesGet } from '../../store/actions/stores';
import { storeGetSetup, storeSelect } from '../../store/actions/store';
import { CountriesList } from './CountriesList';
import { ErrorMessageGeneric } from '../../components/errorMessages/errorMessages';
import { FooterSpacer } from '../../components/FooterSpacer.js/FooterSpacer';
import { Link } from 'react-router-dom';
import { editBookingReset } from '../../store/actions/editBooking';

class StoreList extends Component {
  state = {
    isStoreDetailsVisible: false,
    numberOfCountriesLoaded: 0,
  }

  restaurantClickHandler = async (id, name) => {
    this.props.selectStore(id);
    this.props.getStoreSetup(id);
    this.setState({ isStoreDetailsVisible: true });
  }

  closeModal = () => {
    this.setState({ isStoreDetailsVisible: false });
  }

  continueHandler = () => {
    this.props.onNextStep();
    this.props.history.push({
      pathname: '/persone',
    });
  }

  async componentDidMount() {
    this.props.bookingProcessSetStep();
    if (this.props.isPreselectedStoreLoading) {
      return;
    }
    this.props.getCountries();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isPreselectedStoreSuccess !== prevProps.isPreselectedStoreSuccess
      && this.props.isPreselectedStoreSuccess) {
        this.setState({ isStoreDetailsVisible: true });
    }
  }

  render() {
    let mainComponent = null;
    let termsAndConditionComponent = null;
    if (this.props.isPreselectedStoreLoading) {
      return <LogoLoader />
    }

    if (this.props.isFetchingStores || this.props.isFetchingCountries) {
      mainComponent = <LogoLoader />
    } else if (this.props.hasErrorStores || this.props.hasErrorCountries) {
      mainComponent = ErrorMessageGeneric(this.props.translations.label_error_server);
    } else if (!this.props.selectedCountry) {
      mainComponent = <React.Fragment>
        <p className={globalClasses.PageTitle}>{this.props.translations.label_choose_country}</p>
        <div className={classes.PageContainer}>
          <div className={classes.StoreListContainer}>
            {this.props.countries.map(country => (
              <CountriesList
                key={country.id}
                id={country.id}
                name={country.name}
                imgSrc={country.displayProperties && country.displayProperties.image ? country.displayProperties.image.url : ''}
                onClick={() => {
                  this.props.selectCountry(country);
                  this.props.getStores(country);
                }}
                onLoad={() => {
                  this.setState(prevState => ({ numberOfCountriesLoaded: prevState.numberOfCountriesLoaded + 1 }))
                }}
              />
            ))}
          </div>
          {this.props.countries.length <= this.state.numberOfCountriesLoaded &&
            <Link to="/modifica-prenotazione" className={classes.EditBookingLink} onClick={this.props.resetEditState}>{this.props.translations.label_link_click_to_edit_booking}</Link>
          }
        </div>
      </React.Fragment>
    } else if (this.props.stores.length > 0) {
      mainComponent = <React.Fragment>
        <p className={globalClasses.PageTitle}>{this.props.translations.label_choose_local}</p>
        <div className={classes.StoreListContainer}>
          {this.props.stores
            .map(store => {
              return (
                <RestaurantCard
                  key={store.id}
                  id={store.id}
                  name={store.name}
                  imgSrc={store.logo ? store.logo.url : ''}
                  clicked={this.restaurantClickHandler} />
              )
            })}
        </div>
        <FooterSpacer />
        <Footer
          continueDisabled={true}
          continueLbl={''}
          backClick={() => this.props.selectCountry(null)}
          nextClick={null}
          backDisabled={false}
        />
      </React.Fragment>
    }

    if (this.state.isStoreDetailsVisible) {
      if (this.props.store.isFetching) {
        termsAndConditionComponent = <LogoLoader />;
      } else if (this.props.store.hasError) {
        termsAndConditionComponent = <p className={classes.StorePopupErrorMessage}>{this.props.translations.label_error_server}</p>
      } else if (this.props.store.isOpened === false) {
        termsAndConditionComponent = <p className={classes.StorePopupErrorMessage}>{this.props.translations.label_store_close}</p>
      } else {
        termsAndConditionComponent = (<BookingPolicies
          cancelClick={this.closeModal}
          continueClick={this.continueHandler}
          storeName={this.props.store.storeName}
          termsAndPolic={this.props.storeMessage}
          onToggleTermsAndPrivacy={this.props.onToggleTermsAndPrivacy}
          hasAcceptedTermsAndPrivacy={this.props.hasAcceptedTermsAndPrivacy}
          logo={this.props.store.logo}
          translations={this.props.translations}
          storePopup={this.props.storePopup}
          showPopup={this.props.showPopup}
          goBack={() => this.setState({ isStoreDetailsVisible: false })}
        />)
      }
    }

    return (
      <Aux>
        {this.state.isStoreDetailsVisible ?
          <React.Fragment>
            {termsAndConditionComponent}
            <FooterSpacer />
            <Footer
              continueLbl={this.props.translations.label_continue}
              continueDisabled={!(this.props.hasAcceptedTermsAndPrivacy)}
              backClick={() => this.setState({ isStoreDetailsVisible: false })}
              nextClick={this.continueHandler}
            />
          </React.Fragment>
          :
          mainComponent
        }
      </Aux>
    )
  }
};

const mapStateToProps = state => {
  const { storesReducer, storeReducer, settingsReducer } = state;

  let stores = [];
  if (storesReducer.selectedCountry && storesReducer.stores[storesReducer.selectedCountry.id]) {
    stores = storesReducer.stores[storesReducer.selectedCountry.id];
  }

  let store = null;
  if (storeReducer.stores[storeReducer.storeIdSelected]) {
    store = storeReducer.stores[storeReducer.storeIdSelected];
  }

  let storeMessage = '';
  let storePopup = null;
  let showPopup = false;
  if (store) {
    storeMessage = store.termsAndConditionsTranslation;
    storePopup = store.popupDetails;
    showPopup = store.showPopup;
  }

  return {
    isFetchingCountries: storesReducer.isFetchingCountries,
    hasErrorCountries: storesReducer.hasErrorCountries,
    countries: storesReducer.countries,

    hasAcceptedTermsAndPrivacy: state.bookingProcessReducer.areTermsAccepted && state.bookingProcessReducer.isPrivacyAccepted,

    isFetchingStores: storesReducer.isFetching,
    hasErrorStores: storesReducer.hasError,
    stores,
    storesDetails: storeReducer,
    selectedCountry: storesReducer.selectedCountry,
    store,
    storeMessage,
    translations: settingsReducer.translations,
    storePopup,
    showPopup,
    isPreselectedStoreLoading: state.preselectedStoreState.isLoading,
    isPreselectedStoreSuccess: state.preselectedStoreState.isSuccess,
  };
};


const mapDispatchToProps = dispatch => {
  return {
    onSelectedRestaurant: (id, name, maxPeople, terms, services,) => dispatch({
      type: actionType.SELECTED_RESTAURANT,
      restaurantId: id,
      restaurantName: name,
      maxPeopleNumber: maxPeople,
      termsAndConditions: terms,
      serviceTimes: services
    }),
    onNextStep: () => {
      dispatch(storeAvailabilityReset());
      dispatch(promotionSelect(null));
    },
    selectCountry: country => dispatch(storesSelectCountry(country)),
    bookingProcessSetStep: () => dispatch(bookingProcessSetStep(BOOKING_STEPS.STORE)),
    getCountries: () => dispatch(countriesGet()),
    getStores: country => dispatch(storesGetList(country)),
    getStoreSetup: id => dispatch(storeGetSetup(id)),
    selectStore: id => dispatch(storeSelect(id)),

    onToggleTermsAndPrivacy: () => dispatch(bookingProcessTermsAndPrivacyClicked()),

    resetEditState: () => dispatch(editBookingReset())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreList);


// WEBPACK FOOTER //
// ./src/containers/StoreList/StoreList.js